const TaskDeatilsTab = {
    FILES: 0
}

export default TaskDeatilsTab;
